import setMailListFocusInfo from 'mini-mail-list-store/lib/actions/setMailListFocusInfo';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';

/**
 * Selects a new row that should be focused in the mail list view.
 * @param tableView current table view
 * @param inputIndexToSelect index of the row which should be selected
 */
export default function selectNewConversationUponRowRemoval(
    tableView: TableView,
    inputIndexToSelect: number
): void {
    const tableViewLength = tableView ? tableView.itemIds.length : 0;
    let indexToSelect: number = inputIndexToSelect;

    // Nothing to do if the table is empty
    if (tableViewLength === 0) {
        return;
    }

    // If the selection index ends up out of bounds, reset it to
    // either the top or the bottom of the list
    if (indexToSelect < 0) {
        indexToSelect = 0;
    } else if (indexToSelect > tableViewLength - 1) {
        indexToSelect = tableViewLength - 1;
    }

    setMailListFocusInfo(tableView, { focusedRowId: tableView.itemIds[indexToSelect] });
}
